const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const TabView = require("./TabView");
const URLMake = require("../../shared/URLMake");
const PrivacyTermsUtil = require("./data/PrivacyTerms");
// const Expandable = require("./Expandable.jsx");

const styles = require("./styles/PagePrivacyAndTerms.css");

module.exports = createReactClass({
	displayName: "PagePrivacyAndTerms",

	propTypes: {
		section: PT.oneOf(["privacy", "terms"]),
	},

	renderPrivacy: function() {
		return (
			<div className={styles.main}>
				{PrivacyTermsUtil.getPrivacyContent(styles)}
			</div>
		);
	},

	renderTerms: function() {
		return (
			<div className={styles.main}>
				{PrivacyTermsUtil.getTermsContent(styles)}
			</div>
		);
	},

	render: function() {
		const privacy = this.renderPrivacy();
		const terms = this.renderTerms();
		const selectedTab = this.props.section === "terms" ? 1 : 0;

		const s = String.fromCharCode(160);

		return (
			<TabView
				className={styles.page}
				title={
					"Privacy" + s + "Policy" + s + "- Terms" + s + "&" + s + "Conditions"
				}
				tabTitles={["Privacy Policy", "Terms & Conditions"]}
				tabs={[privacy, terms]}
				tabLinks={[URLMake.forPrivacy(), URLMake.forTerms()]}
				selectedTab={selectedTab}
				tabIndexWithJazz={[0, 1]}
			/>
		);
	},
});
